import {Tag} from "antd";
import React from "react";


const Chip = ({label, value})=>{
    return (
        <Tag
          className={'p-2'}
          bordered={false}
          style={{ background: "#fff", fontSize: '13px' }}
        >
          <span>{label}</span>{' '}
          <span
            style={{
              background: '#ededed',
              borderRadius: '25px',
              textTransform: 'capitalize',
            }}
            className={'px-2 py-1'}
          >
            {value}
          </span>
        </Tag>
    )
}


export default Chip;